import React from 'react';
import './Navbar.css';

const Navbar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleScrollTo = (e, targetId) => {
    e.preventDefault();

    if (targetId === 'top') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setIsSidebarOpen(false);
      return;
    }

    const element = document.getElementById(targetId);
    if (element) {
      const offset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setIsSidebarOpen(false);
    }
  };

  return (
    <>
      <div className="navbar-container">
        <nav className="navbar">
          <div className="navbar-content">
            <div className="nav-links-group desktop-only">
              <a href="#testimonials" className="nav-link" onClick={(e) => handleScrollTo(e, 'testimonials')}>Why us</a>
              <a href="#services1" className="nav-link" onClick={(e) => handleScrollTo(e, 'services1')}>Services</a>
            </div>

            <a href="#" className="nav-logo" onClick={(e) => handleScrollTo(e, 'top')}>
              ProxHelp
            </a>

            <div className="nav-links-group desktop-only">
              <a href="#how-it-works" className="nav-link" onClick={(e) => handleScrollTo(e, 'how-it-works')}>How it works</a>
              <a href="#faq" className="nav-link" onClick={(e) => handleScrollTo(e, 'faq')}>FAQs</a>
            </div>

            <button className="hamburger-menu mobile-only" onClick={toggleSidebar} aria-label="Toggle menu">
              <span className="bar"></span>
              <span className="bar"></span>
              <span className="bar"></span>
            </button>
          </div>
        </nav>
      </div>

      <div className={`sidebar-overlay ${isSidebarOpen ? 'active' : ''}`} onClick={toggleSidebar}></div>

      <div className={`mobile-sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <span className="sidebar-logo">ProxHelp</span>
          <button className="close-sidebar" onClick={toggleSidebar}>&times;</button>
        </div>
        <div className="sidebar-links">
          <a href="#testimonials" className="sidebar-link" onClick={(e) => handleScrollTo(e, 'testimonials')}>Why us</a>
          <a href="#services1" className="sidebar-link" onClick={(e) => handleScrollTo(e, 'services1')}>Services</a>
          <a href="#how-it-works" className="sidebar-link" onClick={(e) => handleScrollTo(e, 'how-it-works')}>How it works</a>
          <a href="#faq" className="sidebar-link" onClick={(e) => handleScrollTo(e, 'faq')}>FAQs</a>
        </div>
      </div>
    </>
  );
};

export default Navbar;
